import './plansFlipButton.css';
import React, { useState } from 'react';

import FlipIcon from '../../assets/icons/flipIcon/flipIcon';

export default function PlansFlipButton({onClick}) {

    const [plansButtonIndex, setPlansButtonIndex] = useState(false);

    const plansButton = ['Individual', 'Enterprise']

    const plansClick = () => {
        setPlansButtonIndex(prev => !prev)
        if(onClick) {
            onClick();
        }
    } 

    return (
        <div className="plans-flip-button-container">
            <div className="plans-button-flip-arrows"><FlipIcon point={true} onClick={onClick}/><FlipIcon point={false} onClick={onClick}/></div>
            <div className="plans-flip-button-back">
                {plansButtonIndex ? plansButton[0] : plansButton[1]}
            </div>
            <div className="plans-flip-button">
                <button className="button" onClick={plansClick}>{plansButtonIndex ? plansButton[1] : plansButton[0]}</button>
            </div>
        </div>
    )
}